import { Guid as P } from "../../shared-lib/index.js";
export default class m {
  constructor() {
    this.jn = {};
  }
  Rt(t) {
    if ("function" != typeof t) return null;
    const i = P.se();
    return (this.jn[i] = t), i;
  }
  removeSubscription(t) {
    delete this.jn[t];
  }
  removeAllSubscriptions() {
    this.jn = {};
  }
  De() {
    return Object.keys(this.jn).length;
  }
  L(t) {
    const i = [];
    for (const s in this.jn) {
      const r = this.jn[s];
      i.push(r(t));
    }
    return i;
  }
}
